<template>
    <div class="fw-dizhi">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <van-address-list
                v-model="addressId"
                :list="list"
                @add="onAdd"
                @edit="onEdit"
        />
        <!--                @select="onClickSelect"-->
    </div>
</template>

<script>
    import {getCookie, } from "../../utils/auth";

    export default {
        data() {
            return {
                title: '地址管理',
                fwUser:{},
                deptId: '',
                token: '',
                addressId: '',
                phone: '',
                list: [],
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.type = this.$route.query.type
            this.getAddressList()
        },
        methods: {
            onAdd() {
                this.$router.push('/addAds')
            },

            onEdit(item) {
                this.$router.push('/editAds?adsId=' + item.id)
            },
            async getAddressList() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwAddressList", data)
                this.list = res.list
                this.addressId = res.adsId
            },

            // onClickSelect(item) {
            //     this.$route.params.adsId = item.id;
            //     this.$router.back();
            // },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            }
        },
    };
</script>

<style lang="scss" scoped>

    .fw-dizhi {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        padding-bottom: 49px;
        background-color: #FAFAFA;
    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }


</style>
